import { GLYPH_24 } from '../../app/brand/brandPaths';

/**
 * The brand mark: the "Ad" of the wordmark — the note-d and all — as one path in a 24-unit box, filled with
 * currentColor (D-1268; kit `.brand-mark`; the same outline as public/icon.svg). Drawn white on the Lagoon
 * square wherever the wordmark has no room: the icon rail, the product preview's rail, the favicon.
 */
export function BrandMark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={GLYPH_24} />
    </svg>
  );
}
